import type { RuntimeCacheEntry } from './storefront-runtime-contract'

const runtimeCache = new Map<string, RuntimeCacheEntry>()

export const getStorefrontRuntimeCache = (cacheKey: string): RuntimeCacheEntry | null => {
  const cached = runtimeCache.get(cacheKey)
  if (!cached || cached.expiresAt <= Date.now()) return null
  return cached
}

export const setStorefrontRuntimeCache = (cacheKey: string, entry: RuntimeCacheEntry): void => {
  runtimeCache.set(cacheKey, entry)
}

export const invalidateStorefrontRuntimeCacheByPluginId = (pluginId: string): void => {
  const normalized = pluginId.trim()
  if (!normalized) return
  const prefix = `${normalized}::`
  Array.from(runtimeCache.keys()).forEach((key) => {
    if (key.startsWith(prefix)) {
      runtimeCache.delete(key)
    }
  })
}

export const clearStorefrontRuntimeCache = (): void => {
  runtimeCache.clear()
}

